import { render, staticRenderFns } from "./MultiChoice.vue?vue&type=template&id=0b8cfb3b&scoped=true&"
import script from "./MultiChoice.vue?vue&type=script&lang=js&"
export * from "./MultiChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultiChoice.vue?vue&type=style&index=0&id=0b8cfb3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8cfb3b",
  null
  
)

export default component.exports